import axios from 'axios';
import qs from 'qs';
import { BASEURL } from '../../config';
import CookieLib from '../helpers/cookieLib';
import { isMobile, getDeviceType } from "../helpers/widgetFunctions";
import history from './history';

import  { Mixpanel } from "../helpers/mixpanel";

const createOptions = (
  url,
  apiMethod,
  query,
  isFormData,
  hasRole,
  isBlobRes,
  isFormEncodeInPut,
) => {
  const sessionId = sessionStorage.getItem("happayVideoKyc.sessionId") || "";
  const channelName = sessionStorage.getItem("happayVideoKyc.channelName") || "";
  const userId = sessionStorage.getItem("happayVideoKyc.userId") || "";
  let deviceType = 'web';

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  if(sessionId) {
    headers["SESSION-ID"] = sessionId;
  }
  if(channelName) {
    headers["Bank-Token"] = channelName;
  }
  headers["VKYC-USER-ID"] = userId;
  
  if(isMobile) {
    deviceType = getDeviceType();
  }
  headers["DEVICE-TYPE"] = deviceType;

  
  
  const options = {
    method: apiMethod.toUpperCase(),
    url: BASEURL + url, // Api URL
    headers: headers,
    timeout: 1200000    // 2mins
  };

  switch (apiMethod.toLowerCase()) {
    // case 'get': {
    //   options.params = query;
    //   if (isBlobRes) {
    //     options.responseType = 'blob';
    //   }
    //   break;
    // }
    // case 'post': {
    //   if (isFormData) {
    //     options.headers['Content-Type'] = 'multipart/form-data';
    //     options.data = query;
    //   } else {
    //     options.data = qs.stringify(query);
    //     options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    //   }
    //   break;
    // }
    case 'put': {
      if (isFormEncodeInPut) {
        options.data = qs.stringify(query);
        options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      } else {
        options.data = query;
      }
      break;
    }
    case 'delete': {
      options.data = query;
      break;
    }
    default:
      options.data = query;
  }
  return options;
};

export const callApi = (
  url,
  apiMethod,
  query,
  isFormData = false,
  hasRole,
  isBlobRes = false,
  isFormEncodeInPut = false,
) =>
  new Promise((resolve, reject) => {
    const options = createOptions(
      url,
      apiMethod,
      query,
      isFormData,
      hasRole,
      isBlobRes,
      isFormEncodeInPut,
    );
    axios(options)
      .then(response => {
        resolve(handleSuccess(response));
      })
      .catch(error => {
        Mixpanel.track(`sbm_kyc_api_error`, {
          url,
          apiMethod,
          // query,
          // err: error
        });
        
        if (error.response && error.response.status === 401) {
          if (
            history &&
            history.location &&
            history.location.pathname !== '/logout'
          ) {
            history.push('/logout', {
              apiCall: false,
              message: 'Your session has expired. ',
            });
          } else {
            handleLogout();
          }
        } else {
          reject(
            handleError(
              error.response || {
                status: 0,
                statusText: error.stack,
                data: { res_str: error.message },
              },
            ),
          );
        }
      });
  });

const handleSuccess = response => {
  const { data, headers } = response;
  if (data && headers && headers['happay-cid'] && headers['happay-token']) {
    // data.headers = headers;
    CookieLib.setCookieByKey('cid', headers['happay-cid']);
    CookieLib.setCookieByKey('token', headers['happay-token']);
  }
  return data;
};
const handleError = error => {
  const { status, statusText, data } = error;
  const errRes = {
    status,
    statusText,
    logout: false,
    data,
  };
  return errRes; // message; // I like to get my error message back
};

export const handleLogout = () => {
  CookieLib.clearAllCookies();
  window.location.href = '/login';
};

export const isProdURL = () => {
  const prdURLs = ['https://api-v2.happay.in/'];
  return prdURLs.includes(BASEURL);
};

export const getWithoutBaseURL = URL =>
  new Promise((resolve, reject) => {
    axios
      .get(URL)
      .then(response => {
        resolve(handleSuccess(response));
      })
      .catch(error => {
        reject(error);
      });
  });
